import { useTranslation } from "react-i18next";
import SVG from "react-inlinesvg";

import { useFormatCurrency } from "@krea/customer-features/hooks";
import CheckSVG from "@krea/customer-features/images/svg/check-colorless.svg";
import Button from "@krea/customer-features/shared-components/button";

import { IGetLoanApplicationsResponse } from "@/services/graphql/loan-application/getLoanApplications";

import settings from "../../settings";

interface IApplicationsSelectorItemProps {
  data: IGetLoanApplicationsResponse["loanApplications"][0];
  checked: boolean;
  onClick: () => void;
}

export const ApplicationsSelectorItem = ({
  data,
  checked,
  onClick,
}: IApplicationsSelectorItemProps) => {
  const title = data.applyingCompany.customerCompany.name;
  const ssn = data.applyingCompany.customerCompany.organisationNumber;
  const currency = settings.currency;
  const [formattedCurrencyValue] = useFormatCurrency({ currency });

  const loanDetails = `${formattedCurrencyValue(data.requestedLoanAmount)} / ${data.requestedPaybackTimeMonths} mo`;
  const { t } = useTranslation();

  return (
    <div
      className="tw-flex tw-items-center tw-overflow-hidden tw-rounded tw-bg-gray tw-px-4 tw-py-3 tw-outline-none focus:tw-outline-none"
      onClick={onClick}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
      aria-label={title}
    >
      <dl className="tw-m-0 tw-w-full tw-p-0 tw-pr-3">
        <dt className="tw-m-0 tw-mb-0.5 tw-text-base tw-font-bold">
          {title} ({ssn})
        </dt>
        <dd className="tw-m-0 tw-text-sm tw-font-bold tw-text-black/65">
          {loanDetails}
        </dd>
      </dl>
      {checked ? (
        <div className="tw-flex tw-h-6 tw-w-6 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary tw-text-white">
          <div className="tw-relative tw-h-3 tw-w-3 [&_svg]:tw-left-0 [&_svg]:tw-top-0 [&_svg]:tw-fill-current">
            <SVG className="tw-absolute tw-h-auto tw-w-full" src={CheckSVG} />
          </div>
        </div>
      ) : (
        <div className="tw-flex tw-shrink-0 tw-items-center tw-justify-center">
          <Button variant="text">{t("applicationSelector.choose")}</Button>
        </div>
      )}
    </div>
  );
};
